import { getProjectIdOrKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT } from './constants.tsx';
import type { ProjectWorkflowContext } from './types.tsx';
import getData from './get-data/index.tsx';

export const projectWorkflowContextResource: RouteResource<ProjectWorkflowContext | null> =
	createResource<ProjectWorkflowContext | null>({
		type: RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT,
		getKey: (matchedRoute) => getProjectIdOrKey(matchedRoute.match, matchedRoute.query),
		getData,
		maxAge: 0,
		isCritical: true,
		isBrowserOnly: true,
	});

export const useWorkflowProjectContext =
	(): UseResourceHookResponse<ProjectWorkflowContext | null> =>
		useResource<ProjectWorkflowContext | null>(projectWorkflowContextResource);
